import * as React from "react";
const TextColorLight = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.97 4.33a.5.5 0 0 0-.94 0l-4 11a.5.5 0 0 0 .94.34l1.517-4.17h4.027l1.516 4.17a.5.5 0 0 0 .94-.34l-4-11Zm1.18 6.17h-3.3l1.65-4.537 1.65 4.537Z", className: "Text" }), /* @__PURE__ */ React.createElement("path", { d: "M4 18h15v3H4z", className: "Color" }));
TextColorLight.displayName = "TextColorLight";
var TextColorLight_default = TextColorLight;
export {
  TextColorLight_default as default
};
